import { render, staticRenderFns } from "./FIBPhotoUpload.vue?vue&type=template&id=f12f608c&"
import script from "./FIBPhotoUpload.vue?vue&type=script&lang=js&"
export * from "./FIBPhotoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports